import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  useTheme,
  Chip,
} from "@mui/material";
import SubCard from "components/common/card/SubCard";
import { useMemo } from "react";
import HeadComponent from "../list/list-head/Head.component";
import { useTranslation } from "react-i18next";

const DetailsStationTable = ({ item }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const TABLE_HEAD = useMemo(
    () => [
      { id: "tag", label: "Tag", alignRight: false, order: true },
      { id: "lat", label: t("Latitude"), alignRight: false, order: true },
      { id: "long", label: t("Longitude"), alignRight: false, order: true },
      { id: "description", label: t("Description"), alignRight: false, order: true },
      {
        id: "connectivityType",
        label: t("Connectivity type"),
        alignRight: false, order: true
      },
    ],
    [t]
  );

  const connectivityType = useMemo(
    () => [
      { label: "4g", value: "4g" },
      { label: t("Optic fiber"), value: "optical_fiber" },
    ],
    [t]
  );

  return (
    <TableContainer>
      <SubCard
        sx={{
          bgcolor: theme.palette.mode === "dark" ? "dark.800" : "grey.50",
          mb: 2,
        }}
        content={false}
      >
        <Table size="small" aria-label="purchases">
          <HeadComponent header={TABLE_HEAD} sx={{ fontSize: 12 }} />

          <TableBody>


            <TableCell align="left">{item?.tag}</TableCell>
            <TableCell align="left">{item?.coordinates.lat}</TableCell>
            <TableCell align="left">{item?.coordinates.long}</TableCell>
            <TableCell align="left">{item?.description}</TableCell>
            <TableCell align="left">
              <Chip
                label={
                  connectivityType.filter(
                    (type) => type.value === item?.connectivityType
                  )[0].label
                }
                size="small"
                sx={{
                  backgroundColor: theme.palette.primary.light,
                  color: theme.palette.primary.main,
                }}
              />
            </TableCell>
          </TableBody>
        </Table>
      </SubCard>
    </TableContainer>
  );
};

export default DetailsStationTable;
